(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    const wwMarkDescriptionContrast = (root = document) => {
    root.querySelectorAll('.ww-product-description-contrast [style]').forEach((element) => {
      const color = element.style.getPropertyValue('color').replace(/\s+/g, '').toLowerCase();
      element.toggleAttribute('data-ww-description-dark-foreground', color === '#404040' || color === 'rgb(64,64,64)');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wwMarkDescriptionContrast(), { once: true });
  } else {
    wwMarkDescriptionContrast();
  }

  document.addEventListener('shopify:section:load', (event) => wwMarkDescriptionContrast(event.target));
  } catch(e) { console.error(e); }
})();

})();
